import { CinImageLabellingMode } from "@cinnamon/design-system/compounds";

import { SingleType, TableType } from "./interface";

export const MIN_WIDTH_SETTING_EDITOR = -250;

// 20Mb
export const MAX_SIZE_UPLOAD = 20 * 1024 * 1024;

export const MAX_FILE_UPLOAD = 1;

// - FSH2406-3817: Disable linecut handler
export const IS_DISABLE_LINECUT_HANDLER = true;

export enum LLM_SAMPLE_EDITOR_MODE {
  CREATE_NEW = "CREATE_NEW",
  CREATE_FROM_JOB = "CREATE_FROM_JOB",
  EDIT = "EDIT",
}

export const TURN_ON_REPLACE_FILE_WITH_EDIT_MODE = [LLM_SAMPLE_EDITOR_MODE.CREATE_NEW, LLM_SAMPLE_EDITOR_MODE.EDIT];
export const NAVIGATE_BACK_AFTER_SAVE_SUCCESS_EDIT_MODE = [
  LLM_SAMPLE_EDITOR_MODE.CREATE_NEW,
  LLM_SAMPLE_EDITOR_MODE.CREATE_FROM_JOB,
];
export const CREATE_SAMPLE_MODES = [LLM_SAMPLE_EDITOR_MODE.CREATE_NEW, LLM_SAMPLE_EDITOR_MODE.CREATE_FROM_JOB];

export const ACCEPT_UPLOAD = {
  "application/pdf": [".pdf"],
  "image/tiff": [".tiff", ".tif"],
  "image/png": [".png"],
  "image/jpeg": [".jpeg", ".jpg"],
};

export const ACCEPT_UPLOAD_VALUE = "pdf, tiff, tif, png, jpeg, jpg";
export const PAGES_COUNT_ALLOWED = 1;

export const EDIT_MODES = [
  CinImageLabellingMode.DrawRectangle,
  CinImageLabellingMode.Edit,
  CinImageLabellingMode.Select,
];

export const POLLING_INTERVAL = 2000;

export enum SETTING_TAB_INDEX {
  SINGLE_VALUE,
  TABLE_VALUE,
}

export const DEFAULT_TABLE_FIELDS = {
  headers: [],
  rows: [],
};

export const HEADER_IMAGE_EDITOR_INFO: Record<SingleType | TableType, { label: string; sampleText: string }> = {
  [SingleType.KEY]: {
    label: "PAGES.LLM_SAMPLE_EDITOR.KEY_SELECTED",
    sampleText: "PAGES.LLM_SAMPLE_EDITOR.SAMPLE_KEY_TEXT",
  },
  [SingleType.VALUE]: {
    label: "PAGES.LLM_SAMPLE_EDITOR.VALUE_SELECTED",
    sampleText: "PAGES.LLM_SAMPLE_EDITOR.SAMPLE_VALUE_TEXT",
  },

  [TableType.HEADERS]: {
    label: "PAGES.LLM_SAMPLE_EDITOR.TABLE_HEADER_SELECTED",
    sampleText: "PAGES.LLM_SAMPLE_EDITOR.SAMPLE_TABLE_HEADER",
  },
  [TableType.ROWS]: {
    label: "PAGES.LLM_SAMPLE_EDITOR.ROW_SELECTED",
    sampleText: "PAGES.LLM_SAMPLE_EDITOR.SAMPLE_TABLE_SELECTED",
  },
};
